import { render, staticRenderFns } from "./Fahrplan.vue?vue&type=template&id=0473b3c0&"
import script from "./Fahrplan.vue?vue&type=script&lang=js&"
export * from "./Fahrplan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports